import type { Piece } from './types';

/**
 * What Curse costs its victim in a fight, the same in every combat mode (D-31): the cursed side's
 * odds are divided by √2, which takes an even fight from 50 % to 41 %. Card mode has always
 * counted it so; Roll, the board AI and the automatic resolution read this same number, and the
 * arena's slow (`CURSE_PACE`) is measured to cost as much.
 */
export const CURSE_LOG_ODDS = 0.5 * Math.LN2;

/** The attacker's log-odds shift from Curse: down if it is cursed, up if its enemy is. Two cursed cancel. */
export function curseLogOdds(attacker: Piece, defender: Piece): number {
  return ((defender.cursed > 0 ? 1 : 0) - (attacker.cursed > 0 ? 1 : 0)) * CURSE_LOG_ODDS;
}
